<div (click)="openModalIfLink($event)" [innerHTML]="content | finSafe: 'html'"></div>

<fcom-modal class="rich-text-modal" [title]="title" [buttons]="ModalButtons.DONE" [(open)]="modalOpen">
  <cms-unstyled-fragment *ngIf="cmsUrl" class="block pr-large" [contentUrl$]="cmsUrl | finToObservable" />
</fcom-modal>
